export default __webpack_public_path__ + "static/media/image_scientist_tablet.36936d8c.png";